import React, { useEffect } from "react";
// import { useHistory } from "react-router-dom";
import { CUSTOMER_SERVICE_TEL } from "../../../config";
import useQuery from "../../../hooks/useQuery";
import { RESERVE_FAIL_TEXT_MAP } from "../config/constants";
import jsbridge from "@xpeng/js-bridge";
import "./index.scss";

export default function () {
  // const history = useHistory();
  const query = useQuery();
  const errorCode = query.get("errorcode");
  const failText = query.get("failtext");
  const special = query.get("special"); // 专项预约

  useEffect(() => {
    document.title = "预约维保";
  }, []);

  const goBack = () => {
    // history.goBack();
    jsbridge.callHandler('closeWindow')
  };

  return (
    <div className="reserve-fail-page">
      <div className="fail-icon"></div>
      <div className="title">预约失败</div>
      <div className="desc">
        {failText ||
          (errorCode && RESERVE_FAIL_TEXT_MAP[errorCode]) ||
          "服务异常。请稍后再试，或者联系客服咨询"}
      </div>
      <div className={`actions-field${special === "1" ? " single-btn" : ""}`}>
        {special !== "1" ? (
          <a
            href={`tel:${CUSTOMER_SERVICE_TEL}`}
            className="service-phone-call"
            onClick={(e) => {
              e.stopPropagation();
              // e.preventDefault();
            }}
          >
            <div className="contact-service-btn">联系客服预约</div>
          </a>
        ) : null}

        <div className="back-modify-btn" onClick={goBack}>
          返回
        </div>
      </div>
    </div>
  );
}
